import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, ApiVisa } from "../../shared";
import { BranchDefaultPricingSchemeHdrContainerModel } from "../../../../../../models/aggregates/branch/branch-default-pricing-scheme-container.model";

@Injectable({
  providedIn: "root",
})
export class BranchDefaultPricingSchemeHdrService extends BaseApiTemplateService<BranchDefaultPricingSchemeHdrContainerModel> {
  constructor(http: HttpClient) {
    super();

    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-pricing-scheme-hdrs/" +
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
      this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "branch-default-pricing-scheme-hdrs/" +
      Core2Config.BACKOFFICE_EP_SUFFIX;
    
      this.httpClient = http;
  }
}